import useIsFeatureEnabled from "PFCore/helpers/use_is_feature_enabled";
import { FeatureFlag } from "PFTypes";

export const useIsChatEnabled = () => useIsFeatureEnabled()(FeatureFlag.Chat);

export default useIsChatEnabled;
